import { MatSnackBarConfig } from '@angular/material/snack-bar';

export class AlertMessage {
  message: string;
  config: MatSnackBarConfig;
  loading: boolean;
}
